// extracted by mini-css-extract-plugin
module.exports = {"gitlab":"SignInWithGitlab_gitlab__3fD3N"};